// extracted by mini-css-extract-plugin
export default {"title":"change-password_title__cq15Z","body":"change-password_body__sTsgX","email":"change-password_email__lvPs1","appName":"change-password_appName__HNes4"};